// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import color from "@pacific/XDL/Utilities/color";
import React from 'react';
import { css } from "styled-components";

interface MiniCartHeaderStyles {
    wrapper?: InjectableCss;
    itemDesc?: TypographyPresentationProps;
    qty?: TypographyPresentationProps;
    total?: TypographyPresentationProps;
}

const styles: MiniCartHeaderStyles = {
    wrapper: {
        css: css`
            display: flex;
            background: ${color('common.ui15')};
            height: 35px;
            width: 100%;
            padding: 8px 16px;
        `,
    },
    itemDesc: {
        variant: "h6",
        css: css`
            width: 300px;
            margin: 0;
            margin-right: 51px;
        `,
    },
    qty: {
        variant: "h6",
        css: css`
            width: 45px;
            margin-right: 15px;
            margin-bottom: 0;
        `,
    },
    total: {
        variant: "h6",
        css: css`
            flex-grow: 1;
            margin: 0;
        `,
    },
};

const MiniCartHeader = () => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.itemDesc}>
                {translate('Item Description')}
            </Typography>
            <Typography {...styles.qty}>
                {translate('QTY')}
            </Typography>
            <Typography {...styles.total}>
                {translate('Total')}
            </Typography>
        </StyledWrapper>
    );
};

export default MiniCartHeader;